import React, { useState } from 'react'
import Table from './Table'
import * as S from "../../styles/ezio-styles/VehiclesPage-styles"
import { vehicleIdDisplay, vehiclesPageTableColumns } from "./TableHelpers"
import { columnsToExcelHeaders, rowsToData } from "../../utils/ezio-utils/ExcelUtils"
import { useMemo, Suspense } from 'react'
import { filterByCategory, filterByGroups, filterByVehicleClass } from '../../utils/ezio-utils/DataUtils'

const ExcelDownloadButton = React.lazy(() => import("./ExcelDownloadButton"));

export default function VehiclesPage({chargeLocations, selectedChargeLocation, req, category, groups, vehicleClasses, beginDate, endDate, electrification, dbDisplayName, userSettings,forceNavigate, loadAllLocations, ALL_LOCATIONS_ID}) {
    const [showPrimaryParkingToolTip, setShowPrimaryParkingToolTip] = useState<Boolean>(false);
    const [cursorCoords, setCursorCoords] = useState({ x: 0, y: 0 });

    const chargeLocation: any = chargeLocations.get(selectedChargeLocation);
    
    const formattedData = useMemo(() => {
        if(!chargeLocation) {return null}
        let data = JSON.parse(JSON.stringify(chargeLocation.vehicleResults))
        // Filter vehicle data based on controls
        data = filterByCategory(data, category);
        data = filterByVehicleClass(data, vehicleClasses);
        data = filterByGroups(data, groups);

        return data.map((vcl) => {
            vcl.asset_id = vehicleIdDisplay(vcl)
            return vcl;
        })
    },[chargeLocation, category, groups, vehicleClasses])

    const handleShowPrimaryParkingToolTip = (show: Boolean, mouseEvent: any) => {
        setCursorCoords({x:mouseEvent.pageX, y:mouseEvent.pageY});
        setShowPrimaryParkingToolTip(show);
    }

    const tableColumns = vehiclesPageTableColumns(forceNavigate);
    const primaryParkingHeader = tableColumns.find((vtc) => vtc.Header === "Primary Parking Location");
    primaryParkingHeader.showToolTip = handleShowPrimaryParkingToolTip;

    return (
        <S.DisplayLayout>
            <S.TableTitle>
                All Vehicles
            </S.TableTitle>
            <S.TableSubtitle>
                This table lists all the vehicles {selectedChargeLocation === ALL_LOCATIONS_ID ? `in your fleet` : `projected to charge at location ${chargeLocation.nickname ? chargeLocation.nickname : chargeLocation.address}`} that match the selected filters.
            </S.TableSubtitle>
            <div style={{position: 'relative'}}>
            {showPrimaryParkingToolTip &&
                <S.TableParkingToolTipWrapper cursorCoords={cursorCoords}
                    onMouseEnter={(e) => {handleShowPrimaryParkingToolTip(true, e)}}
                    onMouseLeave={(e) => {handleShowPrimaryParkingToolTip(false, e)}}
                >
                    <S.ToolTipText>
                        This is the most recent primary parking location of this vehicle, irrespective of date range selection, based on our analysis of its latest 30 days of travel.
                    </S.ToolTipText>
                </S.TableParkingToolTipWrapper>
            }
            </div>
            <Table
                columns={tableColumns}
                data={formattedData}
                type={"details"}
                hoverHighlight={false}
                defaultPrimarySort={{columnId:"assetId",sortDesc:false}}
            />
            <div>
                <Suspense fallback = {<div></div>}>
                    <ExcelDownloadButton
                        csvType={'vehicles'}
                        beginDate={beginDate}
                        endDate={endDate}
                        category={category}
                        groups={groups}
                        vehicleClasses={vehicleClasses}
                        electrification={electrification}
                        location={chargeLocation}
                        db={req.dbName}
                        columns={columnsToExcelHeaders(tableColumns)}
                        data={rowsToData(tableColumns, formattedData, (a: any, b: any) => a.assetId > b.assetId ? 1 : -1)}
                        dbDisplayName={dbDisplayName}
                        userSettings={userSettings}
                        loadAllLocations={loadAllLocations}
                    />
                </Suspense>
            </div>
        </S.DisplayLayout>
  )
}
